// WS-9 — shared template-kind badge. Templates designated a special form
// (CollectionTemplateDto.isSpecialForm) render a distinct "SPECIAL FORM"
// badge (gold, unused by the surrounding kind badges) instead of the
// generic kind badge; ordinary templates render exactly as before
// (status="info", caller-supplied label) so non-special rendering is
// byte-identical at every site.

import { Badge } from "@/design-system/components/ui";
import type { CollectionItemKind } from "@/api/collectionTemplates";

export interface TemplateKindBadgeProps {
  /** The kind label rendered for ordinary templates — callers pass the same
   *  string they previously badged (raw `t.kind` or a display mapping). */
  kind: CollectionItemKind | string;
  /** CollectionTemplateDto.isSpecialForm — only meaningful for Kind=Form. */
  isSpecialForm?: boolean | null;
}

export function TemplateKindBadge({ kind, isSpecialForm }: TemplateKindBadgeProps) {
  if (isSpecialForm) {
    return <Badge status="gold">SPECIAL FORM</Badge>;
  }
  return <Badge status="info">{kind}</Badge>;
}
